/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const add = (userPermissionsList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('userPermissions', 'readwrite');
        const userPermissionsStore = transaction.objectStore('userPermissions');

        userPermissionsStore.clear(); // delete all of the previously added permissions to add the new list

        userPermissionsList.forEach(singlePermission => {
            userPermissionsStore.add(singlePermission);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getByFarmId = (farmId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('userPermissions', 'readonly');
        const userPermissionsStore = transaction.objectStore('userPermissions');

        const userPermission = userPermissionsStore.get(parseInt(farmId));

        transaction.oncomplete = () => {
            db.close();
            if (userPermission.result && userPermission.result) {
                resolve({ success: true, permissions: userPermission.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error })
    }
});

const checkHasPermission = (farmId, permissionType) => new Promise(async (resolve, reject) => {
    try {
        if (farmId && permissionType) {
            const db = await connector();
            const transaction = db.transaction('userPermissions', 'readonly');
            const userPermissionsStore = transaction.objectStore('userPermissions');
            const userPermission = userPermissionsStore.get(parseInt(farmId));

            transaction.oncomplete = () => {
                db.close();
                if (userPermission?.result?.[permissionType]) {
                    resolve({ success: true, permission: true });
                }
                else {
                    resolve({ success: true, permission: false });
                }
            };
        }
        else {
            reject({ success: false, error: 400 });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const userPermissions = {
    add,
    getByFarmId,
    checkHasPermission
}

export default userPermissions;
